import { CommonModule } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { MapsLinkService } from '../../../services/maps-link.service';
import { AlbertaIconModule } from '../../alberta-icon/alberta-icon.module';

export type ContactLinkType = 'address' | 'phone' | 'email';

@Component({
  selector: 'itl-contact-link',
  templateUrl: './contact-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, AlbertaIconModule],
})
export class ContactLinkComponent {
  @Input() type: ContactLinkType = 'address';
  /** display lines, e.g. ['Hauptstraße 5', '51063 Köln']; empty lines are skipped */
  @Input() lines: (string | null | undefined)[] = [];
  /** secondary: alberta-green, variant: link-blue */
  @Input() color: 'secondary' | 'secondary-variant' = 'secondary';
  /** render lines in one row separated by ', ' instead of stacked */
  @Input({ transform: booleanAttribute }) inline = false;

  private readonly icons: Record<ContactLinkType, string> = {
    address: 'alberta-route-navigation-tiny',
    phone: 'alberta-phone-arrow-out-tiny',
    email: 'alberta-paperplane-tiny',
  };

  constructor(private readonly _mapsLinkService: MapsLinkService) {}

  public get iconName(): string {
    return this.icons[this.type];
  }

  public get displayLines(): string[] {
    return (this.lines ?? []).map(line => line?.trim()).filter(line => !!line);
  }

  public get isEmpty(): boolean {
    return this.displayLines.length === 0;
  }

  public open(event: Event): void {
    event.stopPropagation();
    if (this.isEmpty) {
      return;
    }
    const target = this.displayLines.join(', ');
    switch (this.type) {
      case 'address':
        this._mapsLinkService.openAddress(target);
        break;
      case 'phone':
        globalThis.location.href = `tel:${target.replace(/\s+/g, '')}`;
        break;
      case 'email':
        globalThis.location.href = `mailto:${target}`;
        break;
    }
  }
}
